'use client';
import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import Image from 'next/image';
import share from '@/public/doctors-images/share-icon.png';
import phone from '@/public/doctors-images/phone.png'
import { RWebShare } from 'react-web-share';


function ShareButtons({doctorsDetials}) {
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        // Check if window is defined before accessing its properties
        if (typeof window !== 'undefined') {
            setCurrentUrl(window.location.href);
        }
    }, []); 

    return (
        <div className='mt-2 flex gap-2 items-center justify-center sm:justify-start'>
            <RWebShare
                data={{
                    url: currentUrl
                }}
            >
                <Button variant='outline'
                    className='rounded-3xl w-fit h-9 border-primaryBlue text-primaryBlue hover:bg-inherit hover:text-primaryBlue uppercase'>
                    <Image src={share} width={15} height={15} alt='share-btn' className='mr-1' />
                   {doctorsDetials.share}
                </Button>
            </RWebShare>
            <a href="tel:+919829030011">
                <Button variant='outline' className='rounded-3xl w-fit h-9 border-primaryGreen text-primaryGreen hover:bg-inherit hover:text-primaryGreen uppercase'>
                    <Image src={phone} width={15} height={15} alt='share-btn' className='mr-1' />
                    {doctorsDetials.call}
                </Button>
            </a>
        </div>
    );
}

export default ShareButtons;
